import React from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button, Card, Col, Container, Row } from 'react-bootstrap';
import Tier from '@renenet/shared/src/constants/tiers';

const FEATURES = [
  {
    icon: '🔐',
    title: 'Full Privacy',
    body: 'Manual entry, no bank linking. Your data stays yours; securely encrypted on our servers.',
  },
  {
    icon: '📊',
    title: 'Instant Insights',
    body: 'Net worth trends, asset breakdowns, liability tracking, retirement outlook at a glance.',
  },
  {
    icon: '🌍',
    title: 'Global Support',
    body: 'Track 100+ fiat currencies and 800+ cryptocurrencies in one place.',
  },
];

const NAV_CARDS = [
  { icon: '📈', title: 'Net Worth',    body: 'Track your wealth over time.',       to: '/networth' },
  { icon: '🏦', title: 'Assets',       body: 'Manage your asset portfolio.',        to: '/asset'    },
  { icon: '💳', title: 'Liabilities',  body: 'Stay on top of what you owe.',        to: '/liability' },
  { icon: '🔥', title: 'FIRE',         body: 'Plan your path to retirement.',       to: '/fire'     },
];

const Home = (props) => {
  const isPremium = props.userInfo && props.userInfo.tier === Tier.PREMIUM;

  if (props.user) {
    return (
      <Container className="py-4">
        <Row className="mb-4">
          <Col>
            <h3 className="mb-1">Welcome Back, {props.user.attributes.given_name}!</h3>
            {props.userInfo && (
              isPremium
                ? <Badge bg="primary">Premium Plan</Badge>
                : <Badge bg="warning" text="dark">Free Plan</Badge>
            )}
          </Col>
        </Row>
        <Row className="g-3">
          {NAV_CARDS.map(card => (
            <Col xs={12} sm={6} key={card.to}>
              <Card as={Link} to={card.to} className="h-100 text-decoration-none home-nav-card bg-light border-0">
                <Card.Body className="d-flex flex-column">
                  <div className="mb-2" style={{ fontSize: '1.8rem' }}>{card.icon}</div>
                  <Card.Title>{card.title}</Card.Title>
                  <Card.Text className="text-muted flex-grow-1">{card.body}</Card.Text>
                  <span className="text-primary fw-semibold">View →</span>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    );
  }

  return (
    <Container>
      <Row className="py-5 text-center">
        <Col>
          <img alt="" src="/favicon.ico" width="150px" height="150px" className="mb-1" />
          <h1 className="brand-text mb-2" style={{ marginTop: '-8px' }}>moneyplant</h1>
          <h5 className="text-muted mb-4">Your Wealth, Your Way. Completely Private.</h5>
          <p className="lead mb-4">
            Track your financial health without handing over your bank credentials.<br />
            Full control, 100% privacy.
          </p>
          <Button variant="primary" size="lg" onClick={props.onGetStarted}>
            Get Started
          </Button>
        </Col>
      </Row>
      <Row className="g-3 pb-5">
        {FEATURES.map(f => (
          <Col xs={12} md={4} key={f.title}>
            <Card className="h-100 text-center border-0 bg-light">
              <Card.Body>
                <div className="mb-2" style={{ fontSize: '2rem' }}>{f.icon}</div>
                <Card.Title>{f.title}</Card.Title>
                <Card.Text className="text-muted">{f.body}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Home;
